/* EmojiUploadPicker.tsx generated by @compiled/babel-plugin v0.38.1 */
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./EmojiUploadPicker.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useLayoutEffect, useState, useRef, memo, useCallback } from 'react';
import { N300 } from '@atlaskit/theme/colors';
import { FormattedMessage, injectIntl } from 'react-intl-next';
import TextField from '@atlaskit/textfield';
import CrossIcon from '@atlaskit/icon/core/migration/cross';
import AkButton from '@atlaskit/button/standard-button';
import { Text } from '@atlaskit/primitives/compiled';
import FocusLock from 'react-focus-lock';
import * as ImageUtil from '../../util/image';
import debug from '../../util/logger';
import { messages } from '../i18n';
import EmojiErrorMessage from './EmojiErrorMessage';
import EmojiUploadPreview from './EmojiUploadPreview';
import FileChooser from './FileChooser';
import { UploadStatus } from './internal-types';
var closeEmojiUploadButton = null;
var emojiUpload = null;
var emojiUploadTop = null;
var headingH5 = null;
var uploadChooseFileEmojiName = null;
var uploadChooseFileMessage = null;
var uploadChooseFileRow = null;
export var uploadEmojiNameInputTestId = 'upload-emoji-name-input';
export var uploadEmojiComponentTestId = 'upload-emoji-component';
export var cancelEmojiUploadPickerTestId = 'cancel-emoji-upload-picker';
var disallowedReplacementsMap = new Map([[':', ''], ['!', ''], ['@', ''], ['#', ''], ['%', ''], ['^', ''], ['&', ''], ['*', ''], ['(', ''], [')', ''], [' ', '_']]);
var sanitizeName = function sanitizeName(name) {
  // prevent / replace certain characters, allow others
  disallowedReplacementsMap.forEach(function (replaceWith, exclude) {
    name = name.split(exclude).join(replaceWith);
  });
  return name;
};
var maxNameLength = 50;
var toEmojiName = function toEmojiName(uploadName) {
  var name = uploadName.split('_').join(' ');
  return "".concat(name.substr(0, 1).toLocaleUpperCase()).concat(name.substr(1));
};
var ChooseEmojiFile = /*#__PURE__*/memo(function (props) {
  var _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    onChooseFile = props.onChooseFile,
    onClick = props.onClick,
    onNameChange = props.onNameChange,
    onUploadCancelled = props.onUploadCancelled,
    errorMessage = props.errorMessage,
    intl = props.intl;
  var formatMessage = intl.formatMessage;
  var disableChooser = !name;
  var fileChooserButtonDescriptionId = 'choose.emoji.file.button.screen.reader.description.id';
  var inputRef = useRef(null);
  var onKeyDownHandler = useCallback(function (event) {
    if (event.key === 'Escape') {
      onUploadCancelled();
    }
  }, [onUploadCancelled]);
  useLayoutEffect(function () {
    requestAnimationFrame(function () {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    });
  }, []);
  var cancelLabel = formatMessage(messages.cancelLabel);
  var emojiPlaceholder = formatMessage(messages.emojiPlaceholder);
  var emojiNameAriaLabel = formatMessage(messages.emojiNameAriaLabel);
  var emojiChooseFileTitle = formatMessage(messages.emojiChooseFileTitle);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": uploadEmojiComponentTestId,
    className: ax(["_ca0q19bv _u5f319bv _n3td19bv _19bv19bv _4t3icae7 _1e0c1txw _2lx21bp4 _1bah1b1v"])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_11c8dcr7 _n3td1v6z _1e0c1txw _1bah1yb4 _4cvresu3"])
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "new-emoji-name-input",
    className: ax(["_1w901vvm", "_fqoxdcr7 _12r21pd9"]),
    style: {
      "--_bbz764": ix("var(--ds-text-subtle, ".concat(N300, ")"))
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.addCustomEmojiLabel)), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw"])
  }, /*#__PURE__*/React.createElement(AkButton, {
    onClick: onUploadCancelled,
    "aria-label": cancelLabel,
    appearance: "subtle",
    spacing: "none",
    shouldFitContainer: true,
    testId: cancelEmojiUploadPickerTestId
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    color: "currentColor",
    LEGACY_size: "small",
    label: cancelLabel
  })))), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0c1txw _1bah1yb4 _n3td1v6z"])
  }, /*#__PURE__*/React.createElement("span", {
    className: ax(["_16jlkb7n _1o9zkb7n _i0dl1wug _2hwx14y2 _1rwq1j28 _scffidpf _xmji1r31 _gxxuglyw _34ir1o36 _coc6glyw _9bj2glyw"])
  }, /*#__PURE__*/React.createElement(TextField, {
    placeholder: emojiPlaceholder,
    "aria-label": emojiNameAriaLabel,
    maxLength: maxNameLength,
    onChange: onNameChange,
    onKeyDown: onKeyDownHandler,
    value: name,
    isCompact: true,
    autoFocus: true,
    testId: uploadEmojiNameInputTestId,
    ref: inputRef,
    id: "new-emoji-name-input",
    "aria-required": true
  })), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.emojiChooseFileScreenReaderDescription, function () {
    return /*#__PURE__*/React.createElement(FileChooser, {
      label: emojiChooseFileTitle,
      onChange: onChooseFile,
      onClick: onClick,
      accept: "image/png,image/jpeg,image/gif",
      ariaDescribedBy: fileChooserButtonDescriptionId,
      isDisabled: disableChooser
    });
  }))), /*#__PURE__*/React.createElement("div", {
    id: fileChooserButtonDescriptionId
  }, !errorMessage ? /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "small"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.emojiImageRequirements)) : /*#__PURE__*/React.createElement(EmojiErrorMessage, {
    errorStyle: "chooseFile",
    message: errorMessage
  })));
});
var EmojiUploadPicker = function EmojiUploadPicker(props) {
  var _document$activeEleme;
  var errorMessage = props.errorMessage,
    initialUploadName = props.initialUploadName,
    onUploadEmoji = props.onUploadEmoji,
    onFileChooserClicked = props.onFileChooserClicked,
    onUploadCancelled = props.onUploadCancelled,
    _props$disableFocusLo = props.disableFocusLock,
    disableFocusLock = _props$disableFocusLo === void 0 ? false : _props$disableFocusLo,
    intl = props.intl;
  var _useState = useState(errorMessage ? UploadStatus.Error : UploadStatus.Waiting),
    _useState2 = _slicedToArray(_useState, 2),
    uploadStatus = _useState2[0],
    setUploadStatus = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    chooseEmojiErrorMessage = _useState4[0],
    setChooseEmojiErrorMessage = _useState4[1];
  var _useState5 = useState(initialUploadName && sanitizeName(initialUploadName)),
    _useState6 = _slicedToArray(_useState5, 2),
    name = _useState6[0],
    setName = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    filename = _useState8[0],
    setFilename = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    previewImage = _useState0[0],
    setPreviewImage = _useState0[1];
  // document is undefined during ssr rendering and throws an error
  var lastFocusedElementId = useRef(typeof document !== 'undefined' ? (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.id : '');
  useEffect(function () {
    if (errorMessage) {
      setUploadStatus(UploadStatus.Error);
      return;
    } else {
      if (uploadStatus === UploadStatus.Error) {
        setUploadStatus(UploadStatus.Waiting);
      }
    }
  }, [errorMessage, uploadStatus]);
  useEffect(function () {
    if (initialUploadName) {
      setName(sanitizeName(initialUploadName));
    }
  }, [initialUploadName]);
  var clearUploadPicker = useCallback(function () {
    setName(undefined);
    setPreviewImage(undefined);
    setUploadStatus(UploadStatus.Waiting);
  }, []);
  var onNameChange = useCallback(function (event) {
    var newName = sanitizeName(event.target.value);
    if (name !== newName) {
      setName(newName);
    }
  }, [name]);
  var onAddEmoji = useCallback(function () {
    if (uploadStatus === UploadStatus.Uploading) {
      return;
    }
    if (filename && name && previewImage) {
      var notifyUpload = function notifyUpload(size) {
        var width = size.width,
          height = size.height;
        setUploadStatus(UploadStatus.Uploading);
        onUploadEmoji({
          name: toEmojiName(name),
          shortName: ":".concat(name, ":"),
          filename: filename,
          dataURL: previewImage,
          width: width,
          height: height
        }, uploadStatus === UploadStatus.Error, clearUploadPicker);
      };
      ImageUtil.getNaturalImageSize(previewImage).then(function (size) {
        notifyUpload(size);
      }).catch(function (error) {
        debug('getNaturalImageSize error', error);
        // Just set arbitrary size, worse case is it may render
        // in wrong aspect ratio in some circumstances.
        notifyUpload({
          width: 32,
          height: 32
        });
      });
    }
  }, [clearUploadPicker, filename, name, onUploadEmoji, previewImage, uploadStatus]);
  var cancelChooseFile = useCallback(function () {
    setPreviewImage(undefined);
  }, []);
  var errorOnUpload = useCallback(function (event) {
    debug('File load error: ', event);
    setChooseEmojiErrorMessage( /*#__PURE__*/React.createElement(FormattedMessage, messages.emojiUploadFailed));
    cancelChooseFile();
  }, [cancelChooseFile]);
  var onFileLoad = useCallback(function (file) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(f) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setFilename(file.name);
              _context.next = 4;
              return ImageUtil.parseImage(f.target.result);
            case 4:
              setPreviewImage(f.target.result);
              _context.next = 11;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setChooseEmojiErrorMessage( /*#__PURE__*/React.createElement(FormattedMessage, messages.emojiInvalidImage));
              cancelChooseFile();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  }, [cancelChooseFile]);
  var onChooseFile = useCallback(function (event) {
    var files = event.target.files;
    if (files.length) {
      var reader = new FileReader();
      var file = files[0];
      if (ImageUtil.hasFileExceededSize(file)) {
        setChooseEmojiErrorMessage( /*#__PURE__*/React.createElement(FormattedMessage, messages.emojiImageTooBig));
        cancelChooseFile();
        return;
      }
      reader.addEventListener('load', onFileLoad(file));
      reader.addEventListener('abort', errorOnUpload);
      reader.addEventListener('error', errorOnUpload);
      reader.readAsDataURL(file);
    } else {
      cancelChooseFile();
    }
  }, [cancelChooseFile, errorOnUpload, onFileLoad]);
  var cancelUpload = useCallback(function () {
    clearUploadPicker();
    onUploadCancelled();

    // using setTimeout here to allow the UI to update before setting focus
    setTimeout(function (lastFocus) {
      if (lastFocus) {
        var _document$getElementB;
        (_document$getElementB = document.getElementById(lastFocus)) === null || _document$getElementB === void 0 || _document$getElementB.focus();
      }
    }, 0, lastFocusedElementId.current);
  }, [clearUploadPicker, onUploadCancelled]);
  var onChooseFileClicked = function onChooseFileClicked() {
    onFileChooserClicked && onFileChooserClicked();
  };
  var content = name && previewImage ? /*#__PURE__*/React.createElement(EmojiUploadPreview, {
    errorMessage: errorMessage,
    name: name,
    onAddEmoji: onAddEmoji,
    onUploadCancelled: cancelUpload,
    previewImage: previewImage,
    uploadStatus: uploadStatus
  }) : /*#__PURE__*/React.createElement(ChooseEmojiFile, {
    name: name,
    onChooseFile: onChooseFile,
    onClick: onChooseFileClicked,
    onNameChange: onNameChange,
    onUploadCancelled: cancelUpload,
    errorMessage: chooseEmojiErrorMessage,
    intl: intl
  });
  return disableFocusLock ? content : /*#__PURE__*/React.createElement(FocusLock, {
    noFocusGuards: true
  }, content);
};
var EmojiUploadPickerComponent = injectIntl( /*#__PURE__*/memo(EmojiUploadPicker));
export default EmojiUploadPickerComponent;